import naturalCompare from 'app/services/utils/natural-compare.service'
import { EBookLocation, TOCItem } from 'app/types/ebook'

let userOpenedSavedPage = false

export const getUserOpenedSavedPage = () => userOpenedSavedPage
export const setUserOpenedSavedPage = (val: boolean) => {
  userOpenedSavedPage = val
}

function getBookIdFromHref(href: null | undefined | string) {
  if (!href) {
    return 0
  }
  const pageIdRegex = /(\d+)(.xhtml$)/gm
  const pageIdExecResult = pageIdRegex.exec(href)

  // GK_U06_RDR_2ndED17_Final-20170324-epub3-8.xhtml ==> 8
  return pageIdExecResult ? +pageIdExecResult[1] : 0
}

const getSpanishKey = () =>
  window.location.pathname.includes('spanish') ? '-es' : ''

export function getBookId() {
  const bookIdRegex = /reader\d*\/(\d+)/
  const parsedBookId = window.location.pathname.match(bookIdRegex)?.[1] ?? ''
  return parsedBookId + getSpanishKey()
}

function isTocOrdered(tableOfContents: TOCItem[]) {
  let isOrdered = true

  for (let i = 0; i < tableOfContents.length - 1; i++) {
    const currentId = getBookIdFromHref(tableOfContents[i].href)
    const nextId = getBookIdFromHref(tableOfContents[i + 1].href)
    if (currentId > nextId) isOrdered = false
  }
  return isOrdered
}

function getFromOdrdered(endHref: string, tableOfContents: TOCItem[]) {
  let activeIndex = 0
  const endPageId = getBookIdFromHref(endHref)

  const tocIds = tableOfContents.map((tocItem) =>
    getBookIdFromHref(tocItem.href)
  )

  tocIds.forEach((id, index) => {
    const prevId = tocIds[index - 1]
    const nextId = tocIds[index + 1]

    if (endPageId > prevId && endPageId < id) {
      activeIndex = index - 1
    } else if (
      (endPageId >= id || endPageId > prevId) &&
      (endPageId < nextId ||
        // if last item
        nextId === undefined)
    ) {
      activeIndex = index
    }
  })

  return activeIndex
}

export function getActiveTocItemByLocationObject(
  tableOfContents: TOCItem[],
  currentLocationObject: EBookLocation | null
) {
  if (!tableOfContents.length || !currentLocationObject) return 0
  let activeIndex = 0
  const {
    start: { href: startPage },
    end: { href: endPage },
  } = currentLocationObject
  const isOrdered = isTocOrdered(tableOfContents)

  if (isOrdered) {
    try {
      activeIndex = getFromOdrdered(endPage, tableOfContents)
    } catch (e) {
      console.warn('ePub contains no or invalid TOC')
      activeIndex = 0
    }
    return activeIndex
  }

  const tocItem = tableOfContents.find((item, index) => {
    const { href } = item
    if (startPage === href || endPage === href) {
      activeIndex = index
      return true
    }
    return false
  })

  // When active index is 0 (cover page) and TOC is not ordered
  if (tocItem && activeIndex === 0) {
    return 0
  }

  if (!activeIndex) {
    tableOfContents.forEach((item, index) => {
      const { href } = item

      if (href && naturalCompare(startPage, href) >= 0) {
        activeIndex = index
      }
    })
  }

  return activeIndex
}

export function getFlattenedTocItems(tableOfContents: TOCItem[]) {
  const tableOfContentItems: TOCItem[] = []

  tableOfContents.forEach((tocItem) => {
    tableOfContentItems.push(tocItem)

    if (tocItem.subitems && tocItem.subitems.length) {
      tableOfContentItems.push(...tocItem.subitems)
    }
  })

  return tableOfContentItems
}

export function getActiveTocItemByTocPosition(
  tableOfContents: TOCItem[],
  tocPosition?: TOCItem | undefined
) {
  if (!tableOfContents.length || !tocPosition) return 0

  let newIndex = -1
  getFlattenedTocItems(tableOfContents).forEach((item, index) => {
    const { href } = item
    if (href === tocPosition?.href) {
      newIndex = index
    }
  })

  return newIndex
}
